import React, { useState } from 'react';
import { useApp } from '../contexts/AppContext';
import { APP_VERSION, DEPLOY_DATE } from '../config/version';

export default function Login() {
  const { login } = useApp();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    await new Promise(r => setTimeout(r, 300));
    const result = await login(email, password);
    if (!result.ok) {
      if (result.reden === 'inactief') setError('Je account is tijdelijk gedeactiveerd. Neem contact op met de beheerder.');
      else if (result.reden === 'uitdienst') setError('Je account is niet meer actief (uit dienst). Neem contact op met de beheerder.');
      else setError('Onjuiste e-mail of wachtwoord. Neem contact op met de beheerder.');
    }
    setLoading(false);
  };

  return (
    <div style={s.wrapper}>
      <div style={s.card}>
        <div style={s.logoArea}>
          <div style={{ fontSize: 48 }}>🛏️</div>
          <h1 style={s.title}>Slaaploods</h1>
          <p style={s.subtitle}>Verlofbeheer</p>
        </div>
        <form onSubmit={handleSubmit}>
          <div style={s.field}>
            <label style={s.label}>E-mailadres</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} required placeholder="naam@slaaploods.nl" style={s.input} autoComplete="email" />
          </div>
          <div style={{ ...s.field, marginBottom: 24 }}>
            <label style={s.label}>Wachtwoord</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} required placeholder="Jouw wachtwoord" style={s.input} autoComplete="current-password" />
          </div>
          {error && <div style={s.error}>{error}</div>}
          <button type="submit" disabled={loading} style={{ ...s.btn, opacity: loading ? 0.6 : 1 }}>
            {loading ? 'Inloggen...' : 'Inloggen'}
          </button>
        </form>
        <p style={s.hint}>Geen toegang? Neem contact op met de beheerder.</p>
        <div style={{ textAlign: 'center', marginTop: 24, paddingTop: 16, borderTop: '1px solid #f0f0f0', color: '#c8c6c4', fontSize: 10, lineHeight: 1.6 }}>
          <div>Copyright © {new Date().getFullYear()} Willem Reichardt — Slaaploods.nl B.V.</div>
          <div>v{APP_VERSION} · Deploy {DEPLOY_DATE}</div>
        </div>
      </div>
    </div>
  );
}

const s = {
  wrapper: { display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', padding: 16, background: 'linear-gradient(135deg, #1a1a2e 0%, #0f3460 100%)' },
  card: { background: '#fff', borderRadius: 16, padding: '40px 28px', width: '100%', maxWidth: 400, boxShadow: '0 8px 40px rgba(0,0,0,0.3)' },
  logoArea: { textAlign: 'center', marginBottom: 28 },
  title: { fontSize: 26, fontWeight: 700, color: '#1a1a2e', margin: '8px 0 4px' },
  subtitle: { color: '#E86E1C', fontWeight: 600, fontSize: 15, margin: 0 },
  field: { marginBottom: 16 },
  label: { display: 'block', marginBottom: 6, fontWeight: 600, color: '#333', fontSize: 14 },
  input: { width: '100%', padding: '12px 14px', border: '1px solid #ddd', borderRadius: 10, fontSize: 16, boxSizing: 'border-box', WebkitAppearance: 'none' },
  error: { background: '#fde8e8', color: '#c0392b', padding: '10px 14px', borderRadius: 8, marginBottom: 16, fontSize: 14 },
  btn: { width: '100%', padding: 14, background: '#E86E1C', color: '#fff', border: 'none', borderRadius: 10, fontSize: 16, fontWeight: 700, cursor: 'pointer', WebkitAppearance: 'none' },
  hint: { textAlign: 'center', marginTop: 20, color: '#aaa', fontSize: 12 },
};
